import React from 'react';
import { Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { Warning } from '@withjoy/joykit/icons';

type InfoNoticeProps = React.ComponentProps<typeof Flex>;

export const InfoNotice: React.FC<InfoNoticeProps> = ({ children, ...flexProps }) => {
  return (
    <Flex
      rowGap={3}
      justifyContent="center"
      padding={5}
      borderRadius={3}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="info3"
      {...flexProps}
    >
      <IconV2
        color="info5"
        marginRight={2}
      >
        <Warning />
      </IconV2>
      <TextV2 typographyVariant="body1">{children}</TextV2>
    </Flex>
  );
};
